<template>
  <path
    d="M21.65 11.6503L18.86 8.86027C18.54 8.54027 18 8.76027 18 9.21027V11.0003H4C3.45 11.0003 3 11.4503 3 12.0003C3 12.5503 3.45 13.0003 4 13.0003H18V14.7903C18 15.2403 18.54 15.4603 18.85 15.1403L21.64 12.3503C21.84 12.1603 21.84 11.8403 21.65 11.6503Z"
  />
</template>
